import { render, staticRenderFns } from "./ContactComponent.vue?vue&type=template&id=2dd0ae43&scoped=true&"
import script from "./ContactComponent.vue?vue&type=script&lang=js&"
export * from "./ContactComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContactComponent.vue?vue&type=style&index=0&id=2dd0ae43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0ae43",
  null
  
)

export default component.exports